import AddressDto from '@/models/CompanyAddresses/CompanyAddressDto';
import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';
import GeoPoint from '@/models/Shared/GeoPoint';

export default class UpdateAgencyGeneralDetailsRequest extends BaseUpdateRequest {
	registeredName: string;  
    buildingNameNumber = '';
    streetRoadBlock = '';
    locality = '';
    cityTown = '';
    stateProvinceRegion = '';
    postZipCode = '';
    countryCode = '';
    geometry: GeoPoint;       			
	taxNumber: string;          			
	registrationNumber: string; 			
}